import React, { useEffect } from 'react';
import { ErrorState } from '../../../components/states';
import GeneralSettingsForm from '../../../components/forms/GeneralSettingsForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function GeneralSettingsPage() {
  const { requestApi, data, error } = useFetch(`/v1/settings`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <GeneralSettingsForm defaultValues={data?.data} /> : <Loader />;
}
